module.exports = __webpack_public_path__ + "img/home-gift.72011a6.png";